module.exports = __webpack_public_path__ + "img/logo.62e4e237.png";